import React, {
  useState,
  forwardRef,
  useImperativeHandle
} from 'react'
import _ from 'lodash'
import clx from 'classnames'
import styles from './Collapse.css'
import { Tip } from '@vzmi/shp_shared_compo'

const Collapse = forwardRef((props, ref) => {
  const {
    id,
    openText,
    closeText,
    tipsText,
    className,
    children
  } = props
  const [isOpen, setIsOpen] = useState(false)

  const updateCollapse = (newState) => {
    const nextState = _.isUndefined(newState) ? !isOpen : newState
    setIsOpen(nextState)
  }

  const onChange = e => {
    updateCollapse()
    props.onChange && props.onChange(isOpen, e)
  }

  useImperativeHandle(ref, () => ({
    open (newState) {
      updateCollapse(newState)
    }
  }))

  return (
    <div
      className={clx(
        styles.Collapse,
        { [styles.isOpened]: isOpen }
      )}
    >
      <div className={styles.content}>
        {isOpen && children}
      </div>
      <div
        className={clx(
          styles.actionAndTips,
          className
        )}
      >
        <input
          id={id}
          name='collapse-checkbox'
          type='checkbox'
          checked={isOpen}
          onChange={onChange}
        />
        {
          tipsText && (
            <Tip
              type='info'
              className={styles.tips}
            >
              {tipsText}
            </Tip>
          )}
        <label
          htmlFor={id}
          className={clx(
            styles.action,
            props.actionClassName
          )}
        >
          {isOpen ? closeText : openText}
        </label>
      </div>
    </div>
  )
})

export default Collapse
